const padDatePart = (value) => String(value).padStart(2, '0');

export const getDateInTimezone = (date, timezone) => {
  if (!date || !timezone) return date;
  return new Date(new Date(date).toLocaleString('en-US', { timeZone: timezone }));
};

export const formatLocalDateTime = (date) => {
  if (!date) return null;

  const parsedDate = new Date(date);
  const year = parsedDate.getFullYear();
  const month = padDatePart(parsedDate.getMonth() + 1);
  const day = padDatePart(parsedDate.getDate());
  const hours = padDatePart(parsedDate.getHours());
  const minutes = padDatePart(parsedDate.getMinutes());
  const seconds = padDatePart(parsedDate.getSeconds());

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const serializeCampaignSendAt = ({ date }) => formatLocalDateTime(date);
